export default {
    no_session: "No available app",
    new_messages: "New messages",
    send_to: "Send to ",

    loading: "loading",
};
